import React, { useEffect, useMemo, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Breadcrumb from '../Common/Breadcrumb';
import { Tabs, TabsList, TabsTrigger } from '../ui/tabs';
import { Actions as DASHBOARDACTIONS } from '../../store/actions/dashboardActions';
import { showLoader } from '../../store/action';
import { useHistory, useParams } from 'react-router-dom';
import { NoPermissions } from '../Common/ReusableComponents/Reusable';
import NetZeroTarget from './NetZeroTarget';
import IntensityTarget from './IntensityTarget';

const NetZero = ({ orgDetails, currentOrg, branding, orgTargets, netZero }) => {
  const { id } = useParams();
  const history = useHistory();
  const currentTarget = useMemo(() => {
    return (orgTargets && orgTargets.length > 0 && orgTargets?.find((target) => target.id === id)) || null;
  }, [orgTargets, id]);
  const [page, setPage] = useState(
    id === 'new'
      ? 'netzero'
      : currentTarget && currentTarget?.settingMethod === 'Absolute Contraction'
      ? 'netzero'
      : !currentTarget
      ? 'netzero'
      : 'intensity'
  );
  useEffect(() => {
    if (orgTargets && orgTargets.length > 0 && id !== 'new') {
      const target = orgTargets.find((target) => target.id === id);
      if (target) {
        setPage(target?.settingMethod === 'Absolute Contraction' ? 'netzero' : 'intensity');
      }
    }
  }, [orgTargets, id]);

  const prevOrg = useRef();

  useEffect(() => {
    if (currentOrg) {
      //Taking users back to the table page when switching orgs to avoid editing targets of another org
      if (id && prevOrg.current && currentOrg) {
        history.push('/netZero');
      }
      prevOrg.current = currentOrg;
    }
  }, [currentOrg, id]);

  if (!netZero) {
    return <NoPermissions />;
  }

  return (
    <React.Fragment>
      <Breadcrumb
        items={[
          { label: 'Science Based Targets', link: '/netZero' },
          { label: id === 'new' ? 'New target' : 'Target', link: `/netZero/${id}` },
        ]}
      />
      <div className='w-full font-body'>
        <div className='rounded-xl border border-border bg-card shadow-sm'>
          <header className='border-b border-border px-6 py-4'>
            <h2 className='text-lg font-semibold text-foreground font-body mb-4'>Science Based Targets</h2>
            <Tabs value={page} onValueChange={setPage}>
              <TabsList className='rounded-lg border border-border p-1 bg-muted/30'>
                <TabsTrigger
                  value='netzero'
                  disabled={id !== 'new' && currentTarget?.settingMethod !== 'Absolute Contraction'}
                  className='text-sm font-body data-[state=active]:bg-background data-[state=active]:text-foreground'>
                  Net Zero - Absolute
                </TabsTrigger>
                <TabsTrigger
                  value='intensity'
                  disabled={id !== 'new' && currentTarget?.settingMethod !== 'Physical intensity convergence'}
                  className='text-sm font-body data-[state=active]:bg-background data-[state=active]:text-foreground'>
                  Net Zero - Intensity
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </header>
          <div className='p-6'>
            {page === 'netzero' ? <NetZeroTarget /> : <IntensityTarget />}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const features = state?.features;
  const availableFeatures = state.organisation?.details?.features;
  const sbtFeature = features?.find((feature) => feature.featureKey === 'SCIENCE_BASED_TARGETS');
  const netZero = availableFeatures?.includes('SCIENCE_BASED_TARGETS') || sbtFeature?.enabledByDefault || false;
  return {
    orgDetails: state?.organisation?.details,
    currentOrg: state.currentOrganisation,
    branding: state?.branding?.colors,
    loader: state?.showLoader,
    orgTargets: state?.dashboard?.targets,
    netZero,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sumValues: (data, year, org, dataType, ignoreCache) =>
    dispatch(DASHBOARDACTIONS.sumValues(data, year, org, dataType, ignoreCache)),
  saveTargets: (targets) => dispatch(DASHBOARDACTIONS.saveTargets(targets)),
  showLoader: (show) => dispatch(showLoader(show)),
  getTargets: () => dispatch(DASHBOARDACTIONS.getTargets()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetZero);
